/**
 * @file SettingsPage.js
 * @author Simon Tenedero
 * @created 2025-07-07
 * @lastModified 2025-07-07
 * @description file containing the SettingsPage component.
 */

/**
 * This page allows users to manage their account settings, including changing their profile picture and display name.
 * NOTE: this component is not implemented yet.
 *
 * @returns {JSX.Element} The rendered SettingsPage component
 */
const SettingsPage = () => {
  return (
    <div className="settings-page">
      <div className="settings-header min-h-screen">
        <h1 className="font-bold text-4xl flex justify-center m-5">Settings</h1>
      </div>
    </div>
  );
};

export default SettingsPage;
